import { render, staticRenderFns } from "./UnapprovedPOs.vue?vue&type=template&id=d7e06790&scoped=true"
import script from "./UnapprovedPOs.vue?vue&type=script&lang=ts"
export * from "./UnapprovedPOs.vue?vue&type=script&lang=ts"
import style0 from "./UnapprovedPOs.vue?vue&type=style&index=0&id=d7e06790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e06790",
  null
  
)

export default component.exports